import script from "./LingoButtonComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./LingoButtonComponent.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__